import axios from "axios";

import { READ_BASE_URL } from ".";
import { FileDetails } from "../types/FileDetails";

interface SummaryRequest {
	fileId: string;
	summaryLength: number;
	summaryLanguage: string;
	summaryLevel: string;
	summaryTopic: string;
}

export class ArticleProcessingService {
	public static async getSummary(data: SummaryRequest) {
		const response = await axios.post(READ_BASE_URL + "/articleProcessing/getSummary", data);
		return response.data;
	}

	public static async requeueArticleForProcessing(fileId: string) {
		const response = await axios.post<FileDetails>(READ_BASE_URL + `/articleProcessing/requeue/${fileId}`);
		return response.data;
	}
}